import React from 'react';
import { ShieldCheck, Check } from 'lucide-react';
import { Button } from './Button';
export function Pricing() {
  return <section className="py-16 px-4 md:px-8 bg-white" data-id="element-47">
      <div className="max-w-3xl mx-auto" data-id="element-48">
        {/* Value Justification */}
        <div className="text-center mb-16" data-id="element-49">
          <h2 className="text-3xl font-bold text-brand-textDark mb-8" data-id="element-50">
            ¿Por qué este Mega Pack vale mucho más de lo que cuesta?
          </h2>
          <div className="space-y-4 text-lg text-brand-text text-left max-w-2xl mx-auto bg-brand-bg p-8 rounded-2xl border border-gray-100" data-id="element-51">
            <p data-id="element-52">
              Porque una sola idea que cambie la forma en la que resolvés una
              rabieta puede evitar años de conflictos.
            </p>
            <p data-id="element-53">Porque mejorar la relación con tus hijos no tiene precio.</p>
            <p data-id="element-54">
              Y porque aprender herramientas que podés usar durante toda la
              infancia es una inversión para toda la familia.
            </p>
            <p className="font-bold text-brand-sageDark pt-4 text-center" data-id="element-55">
              Hoy no vas a pagar el valor real.
            </p>
          </div>
        </div>

        {/* Pricing Card */}
        <div className="bg-brand-bg rounded-3xl shadow-xl border border-brand-sage/30 overflow-hidden" data-id="element-56">
          <div className="bg-brand-sage text-white text-center py-4 font-bold text-xl tracking-wide uppercase" data-id="element-57">
            Oferta Especial
          </div>
          <div className="p-8 md:p-12 text-center" data-id="element-58">
            <h3 className="text-2xl font-bold text-brand-textDark mb-2" data-id="element-59">
              Accedé al Mega Pack Crianza con Calma por solo
            </h3>
            <div className="text-6xl font-extrabold text-brand-sageDark my-6" data-id="element-60">
              USD 10
            </div>

            <div className="space-y-3 text-left max-w-xs mx-auto mb-8" data-id="element-61">
              <div className="flex items-center text-brand-textDark font-medium" data-id="element-62">
                <Check className="w-5 h-5 text-brand-sage mr-3 shrink-0" data-id="element-63" /> Pago
                único.
              </div>
              <div className="flex items-center text-brand-textDark font-medium" data-id="element-64">
                <Check className="w-5 h-5 text-brand-sage mr-3 shrink-0" data-id="element-65" />{' '}
                Acceso inmediato.
              </div>
              <div className="flex items-center text-brand-textDark font-medium" data-id="element-66">
                <Check className="w-5 h-5 text-brand-sage mr-3 shrink-0" data-id="element-67" />{' '}
                Descarga digital.
              </div>
              <div className="flex items-center text-brand-textDark font-medium" data-id="element-68">
                <Check className="w-5 h-5 text-brand-sage mr-3 shrink-0" data-id="element-69" />{' '}
                Acceso de por vida.
              </div>
            </div>

            <p className="text-sm text-brand-text mb-8 bg-white p-3 rounded-lg border border-gray-100 inline-block" data-id="element-70">
              Sin cuotas. Sin suscripciones. Sin pagos ocultos.
              <br data-id="element-71" />
              <strong className="text-brand-textDark" data-id="element-72">
                Comprás una vez y el material será tuyo para siempre.
              </strong>
            </p>

            <div className="space-y-6" data-id="element-73">
              <div className="text-left bg-brand-peach/10 p-6 rounded-xl border border-brand-peach/20 mb-6" data-id="element-74">
                <h4 className="font-bold text-brand-textDark mb-2 text-xl" data-id="element-75">
                  Empezá hoy mismo
                </h4>
                <p className="text-brand-text mb-4" data-id="element-76">
                  Cada día que pasa sin nuevas herramientas es un día más
                  enfrentando las mismas dificultades.
                </p>
                <p className="text-brand-text font-medium" data-id="element-77">
                  Hoy podés elegir seguir improvisando... O empezar a criar con
                  más tranquilidad, comprensión y confianza.
                </p>
              </div>

              <Button href="https://mega-pack-crianza-con-calma.impultienda.ar/checkout" fullWidth className="text-xl py-5 shadow-xl shadow-brand-sage/20" data-id="element-78">
                Hacé clic aquí y obtené acceso inmediato
              </Button>

              <div className="flex justify-center items-center space-x-2 text-sm text-gray-500 mt-4" data-id="element-79">
                <ShieldCheck className="w-4 h-4 text-brand-sage" data-id="element-80" />
                <span data-id="element-81">Pago 100% Seguro</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}